import React from "react";
import { useTranslation } from "react-i18next";
import PathLink from "../../shared/seo/PathLink";
import { urls } from "../../shared/seo/links";
import "./content.css";

// Magazine topics that have content in this language: [{ key, count }].
export default function TopicLinks({ topics, lang, current }) {
  const { t } = useTranslation();
  const list = (topics || []).map((topic) => urls.findCategory(topic.key)).filter(Boolean);
  if (list.length === 0) return null;
  return (
    <nav className="avc-topics" aria-label={t("topics_title")}>
      <span className="avc-topics__label">{t("topics_title")}</span>
      <ul>
        {list.map((category) => (
          <li key={category.key}>
            <PathLink
              to={urls.categoryPath(category, lang)}
              className="avc-topics__chip"
              aria-current={current === category.key ? "page" : undefined}
            >
              {urls.categoryName(category, lang)}
            </PathLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
